// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4328":"Widgets","5240":"volto-dropdownmenu-manage","5772":"plone-volto-components-manage-Controlpanels-Aliases"}[chunkId] + "." + {"4328":"92418357","5240":"f0610ba2","5772":"92418357"}[chunkId] + ".chunk.css";
};